'use strict';

var invariant = require('invariant');
var canUseDOM = require('can-use-dom');

var History = {

  /**
   * The current number of entries in the history.
   *
   * Note: This property is read-only.
   */
  length: 1,

  /**
   * Sends the browser back one entry in the history.
   */
  back: function back() {
    invariant(canUseDOM, 'Cannot use History.back without a DOM');

    // Do this first so that History.length will
    // be accurate in location change listeners.
    History.length -= 1;

    window.history.back();
  }

};

module.exports = History;


//////////////////
// WEBPACK FOOTER
// ./~/react-router/lib/History.js
// module id = 250
// module chunks = 1